<div class="list-page" style="max-width: 2000px; padding: 1em">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Päätilikartta: <a [href]="tilikarttaEncodedUriObservable | async" target="_BLANK">{{ tilikarttaUriObservable | async }}</a>
      </div>
    </div>
  }

  <mat-tab-group>
    <mat-tab label="Päätilikartta">
      <div style="padding: 1em">
        <div style="width: 500px; display: flex; flex-flow: row; justify-content: space-between; align-items: baseline; margin-bottom: 10px">
          <div style="width: 100px">
            <mat-form-field>
              <mat-label>Näytä kielellä</mat-label>
              <mat-select [formField]="kieliValinta" (selectionChange)="kieliMuuttui($event)" style="width: 100%">
                <mat-option value="fi">Suomi</mat-option>
                <mat-option value="en">Englanti</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (voidaanMuokataPaatilikarttaaObservable | async) {
            <app-primary-button (click)="lisaa()" actionId="Avasi dialogin: Lisää tili päätilikarttaan" additionalClass="mat-elevation-z4" styles="padding-left: 8px;" matIcon="add"> Lisää tili </app-primary-button>
          }
        </div>

        @if (commonError()) {
          <div class="error-text">{{ commonError() }}</div>
        }

        @if (loading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <div class="example-list" [class.hidden]="loading()" cdkDropList (cdkDropListDropped)="drop($event)">
          @for (node of flatatyt | async; track node) {
            <div (click)="muokkaa(node.kirjanpitotili)" class="example-box" [style.padding-left]="node.level * 15 + 'px'" cdkDrag>
              {{ node.name }}
            </div>
          }
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Profiilit">
      <div app-profiili-paatilikartta style="padding: 1em"></div>
    </mat-tab>
  </mat-tab-group>
</div>
